enum InventorySubType {
  WEB_DASHBOARD = "WEB_DASHBOARD",
  WEB_PROFILE_FORM = "WEB_PROFILE_FORM",
  MOBILE_DASHBOARD = "MOBILE_DASHBOARD",
  REGISTRATION = "REGISTRATION",
  WEB_TABLETALK_AGENDA = "WEB_TABLETALK_AGENDA",
  MOBILE_TABLETALK_AGENDA = "MOBILE_TABLETALK_AGENDA",
  MOBILE_EVENT_AGENDA_SPONSOR = "MOBILE_EVENT_AGENDA_SPONSOR"
}

export default InventorySubType;

export const MobileSpecificInventorySubTypeList = [
  InventorySubType.MOBILE_DASHBOARD,
  InventorySubType.MOBILE_TABLETALK_AGENDA,
  InventorySubType.MOBILE_EVENT_AGENDA_SPONSOR
];
export const DetailedFormRequiredForInventorySubType = [
  InventorySubType.WEB_DASHBOARD,
  InventorySubType.WEB_PROFILE_FORM
];

export const SupportedInventorySubTypeOnWeb = [
  InventorySubType.WEB_DASHBOARD,
  InventorySubType.WEB_PROFILE_FORM,
  InventorySubType.WEB_TABLETALK_AGENDA
];
